exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ico_print[data-v-4964c970]:before{content:\"\\F029\"}.qr_modal[data-v-4964c970]{position:fixed;top:0;bottom:0;right:0;left:0;z-index:1050;outline:0;background:#00000085}.scan_btn[data-v-4964c970]{position:absolute;top:35%;right:8%;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4964c970","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Drawing/Main.vue
// module id = 243
// module chunks = 0